import { render, staticRenderFns } from "./ProductFormVariantSellTime.vue?vue&type=template&id=60964228&"
import script from "./ProductFormVariantSellTime.vue?vue&type=script&lang=js&"
export * from "./ProductFormVariantSellTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports